import { render, staticRenderFns } from "./RelatedProduct.html?vue&type=template&id=60babce8&scoped=true&"
import script from "./RelatedProduct.vue?vue&type=script&lang=js&"
export * from "./RelatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProduct.scss?vue&type=style&index=0&id=60babce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60babce8",
  null
  
)

export default component.exports